// Native authentication configuration for Microsoft Entra External ID
// This runs alongside the existing MSAL redirect-based auth (authConfig.js)
// Import types from custom-auth module
import type { CustomAuthConfiguration } from '@azure/msal-browser/custom-auth';
import { LogLevel } from '@azure/msal-browser';

const clientId = import.meta.env.REACT_APP_ENTRA_CLIENT_ID || 'f1bc35de-584b-4c01-8f4c-57736248c764';
const authority = import.meta.env.REACT_APP_ENTRA_AUTHORITY || 'https://billsautomation.ciamlogin.com/d290d079-31b1-49c7-bac1-314599c082b3';

// API proxy URL - in production it's the same domain, locally it's the Functions host
const apiBaseUrl = import.meta.env.REACT_APP_API_URL || 'http://localhost:7071/api';

export const customAuthConfig: CustomAuthConfiguration = {
    customAuth: {
        challengeTypes: ['password', 'oob', 'redirect'],
        authApiProxyUrl: `${apiBaseUrl}/nativeauth`,
    },
    auth: {
        clientId,
        authority,
        redirectUri: '/',
        postLogoutRedirectUri: '/',
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: 'localStorage',
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
                if (containsPii) return;
                if (import.meta.env.DEV) {
                    switch (level) {
                        case LogLevel.Error:
                            console.error('[NativeAuth]', message);
                            break;
                        case LogLevel.Warning:
                            console.warn('[NativeAuth]', message);
                            break;
                        case LogLevel.Info:
                            console.info('[NativeAuth]', message);
                            break;
                    }
                }
            },
        },
    },
};
